import { render, staticRenderFns } from "./PlanVsResult.vue?vue&type=template&id=6c525869&"
import script from "./PlanVsResult.vue?vue&type=script&lang=js&"
export * from "./PlanVsResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports